<!-- Reuse this v-data-table inline edit dialog for e.g. mobile cards view.

Must wrap in <div slot="input">...</div>

-->
<template>
  <v-edit-dialog
    :return-value.sync="decoder.store.association_membernumber"
    lazy
    :large="large"
    :cancel-text="$t('cancel')"
    :save-text="$t('save')"
    @save="$emit('update', decoder.store)"
  >
    <span class="editable-store-association-membernumber">
      <span v-if="decoder.store.association_membernumber">
        {{ decoder.store.association_membernumber }}
        <v-btn
          v-if="showIcon"
          icon
          small
          flat
          class="ma-0"
          color="msr"
        >
          <v-icon small>edit</v-icon>
        </v-btn>
      </span>
      <span v-else>
        <v-icon>add</v-icon>
      </span>
    </span>
    <template slot="input">
      <div class="my-3">
        <h5 class="body-2 mb-2">
          {{ $t('storeAssociationMemberNumberEdit') }}
        </h5>
        <div
          class="caption grey--text text--darken-3"
          style="max-width: 320px"
        >
          {{ $t('storeAssociationMemberNumberEditHint') }}
        </div>
        <v-text-field
          v-model="decoder.store.association_membernumber"
          :rules="[(v) => (!!v && v.length <= 64) || $t('tooLong')]"
          counter="64"
          class="mt-3 mb-2"
          clearable
          :label="$t('storeAssociationMemberNumber')"
        />
      </div>
    </template>
  </v-edit-dialog>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {
    /* Expected to have .store and .store.association_membernumber fields. */
    decoder: {
      type: Object,
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.editable-store-association-membernumber:hover * {
  color: var(--msr-color-primary);
}
</style>



// WEBPACK FOOTER //
// src/components/DecoderEditStoreAssociationInline.vue